import { useEffect, useState, createContext, useContext } from "react";
import { HitLoadingBlock } from "@/components/loading";
import { api } from "@/lib/api";
import { X, FileText } from "lucide-react";
import LegalContent from "@/components/LegalContent";

const LegalCtx = createContext(null);

const KNOWN = {
  terms: "Términos y Condiciones",
  privacy: "Política de Privacidad",
  prohibited: "Artículos Prohibidos",
  image_rights: "Imágenes de cartas y propiedad intelectual",
  auction_terms: "Términos y Condiciones de Subastas",
};

export function LegalModalProvider({ children }) {
  const [slug, setSlug] = useState(null);
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(false);

  const open = (s) => {
    setSlug(s);
    setDoc(null);
    setLoading(true);
    api.get(`/legal/${s}`)
      .then((r) => setDoc(r.data))
      .catch(() => setDoc({ title: KNOWN[s] || s, content: "No se pudo cargar el documento." }))
      .finally(() => setLoading(false));
  };
  const close = () => { setSlug(null); setDoc(null); };

  return (
    <LegalCtx.Provider value={{ open, close }}>
      {children}
      {slug && (
        <div
          className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-4 pt-[max(1rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))]"
          onClick={close}
          data-testid="legal-modal-backdrop"
        >
          <div
            className="bg-[#111] border border-[#262626] rounded-lg max-w-3xl w-full overflow-hidden flex flex-col"
            style={{ maxHeight: "calc(100dvh - 2rem - env(safe-area-inset-top) - env(safe-area-inset-bottom))" }}
            onClick={(e) => e.stopPropagation()}
            data-testid="legal-modal"
          >
            <div className="flex items-center justify-between p-5 border-b border-[#262626]">
              <div className="flex items-center gap-3">
                <FileText size={22} className="text-[#EF4444]" />
                <h2 className="font-display text-2xl">{doc?.title || KNOWN[slug] || slug}</h2>
              </div>
              <button
                type="button"
                onClick={close}
                data-testid="legal-modal-close"
                className="text-neutral-500 hover:text-white"
              >
                <X size={22} />
              </button>
            </div>
            <div className="p-5 sm:p-6 overflow-y-auto" data-testid="legal-modal-body">
              {loading ? <HitLoadingBlock section="legal" /> : <LegalContent content={doc?.content || ""} />}
            </div>
          </div>
        </div>
      )}
    </LegalCtx.Provider>
  );
}

export function useLegalModal() {
  const ctx = useContext(LegalCtx);
  if (!ctx) throw new Error("useLegalModal fuera del provider");
  return ctx;
}
